import { Routes, Route } from 'react-router-dom';
import { allPages, Page } from '../../pages';

export const AppRoutes = () => {
  return (
    <Routes>
      {allPages.map((page: Page, index) => (
        <Route key={index} path={page.path} element={page.content} />
      ))}
    </Routes>
  );
};
